/** 获取去重后的详细地址（省市区镇名称和详细地址有重复时）
  *  @param {string} province 省名称
  *  @param {string} city 市名称
  *  @param {string} district 区名称
  *  @param {string} town 镇名称
  *  @param {string} detail 详细地址的字符串
  *  @returns {string} 返回对应的详细地址的字符串
  */
export const dealDetailAddress = (province = '', city = '', district = '', town = '', detail = '') => {
    if (!detail) return '';
    return detail.replace(province, '').replace(city, '').replace(district, '').replace(town, '');
};

/** 获取去重后的完整详细地址（拼接了省市区镇）
  *  @param {string} province 省名称
  *  @param {string} city 市名称
  *  @param {string} district 区名称
  *  @param {string} town 镇名称
  *  @param {string} detail 详细完整的地址的字符串
  *  @returns {string} 返回对应的详细地址的字符串
  */
export const filterDetailAddress = (province = '', city = '', district = '', town = '', detail = '') => {
    if (!detail) return '';
    return `${province}${city}${district}${town}${dealDetailAddress(province, city, district, town, detail)}`;
};